import React, { Component } from "react";
// 图片
import noData from "@/assets/img/no_data.png";
// 国际化切换语言
import { connect } from "react-redux";
import { injectIntl } from "react-intl";

@connect((state) => state)
class NoData extends Component {
  constructor(props) {
    super(props);
    this.props = props;
  }

  render() {
    return (
      <div className="no_data">
        <div className="no_data_img">
          <img alt="" src={noData} className="pic" />
        </div>
        <div className="wenzi">暂无数据</div>
      </div>
    );
  }
}

export default injectIntl(NoData);



// WEBPACK FOOTER //
// ./src/AntD/components/common/no_data.js